var Gallery;

Gallery = function(gallery_id, options) {
  self.id = gallery_id;
  self.assets = (function(_this) {
    return function(options, callback) {
      return api.galleries.assets.read(self.id, options).done(callback);
    };
  })(this);
  self.asset_add = (function(_this) {
    return function(asset_id, callback) {
      return api.galleries.assets.create(self.id, {
        asset_id: asset_id
      }).done(callback);
    };
  })(this);
  self.move_asset = (function(_this) {
    return function(asset, to, callback) {
      return api.galleries.assets.update(self.id, asset.id, {
        sort: to
      }).done(callback);
    };
  })(this);
  self.asset_delete = (function(_this) {
    return function(asset_id, callback) {
      return api.galleries.assets.destroy(self.id, asset_id).done(callback);
    };
  })(this);
  return self;
};

if (api.galleries == null) {
  api.add('galleries');
}

api.galleries.add('assets');

//# sourceMappingURL=gallery.js.map
